import AppIcon from 'components/common/AppIcon/AppIcon';
import utils from 'helpers/utils';
import {upperFirst} from 'lodash';
import {rgba} from 'polished';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import {colors} from 'styles/shared';
import PlanCheckIcon from './PlanCheckIcon';

const PlanContainer = styled.div`
  width: 44.6rem;
  height: 20rem;
  background: ${props => rgba(props.background, 0.6)};
  border-radius: 3rem;
  padding: 2.5rem 2.6rem 0 3.2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  border: ${props => (props.active ? `0.2rem solid ${props.color}` : '0.2rem solid transparent')};
`;

const PlanRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 3rem;
  line-height: 3.6rem;
  color: ${props => props.color};
`;

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

const MainText = styled.span`
  font-size: 3rem;
  line-height: 3.6rem;
  color: ${props => props.color};
`;

const Devider = styled.span`
  font-size: 1.5rem;
  color: ${props => rgba(props.color, 0.4)};
  margin: 0 1rem;
`;

const RequestContainer = styled.div`
  height: 3.6rem;
  background: ${colors.blue_lightest};
  border-radius: 1.5rem;
  padding: 0.8rem 1.3rem;
  display: flex;
  align-items: center;
  width: fit-content;
  margin-bottom: 3.2rem;
`;

const RequestText = styled.span`
  font-size: 1.9rem;
  line-height: 2.4rem;
  color: ${props => rgba(props.color, 0.5)};
`;

const RequestDevider = styled.span`
  font-size: 1.4rem;
  color: ${props => rgba(props.color, 0.3)};
  margin: 0 1rem;
`;

PlanItem.propTypes = {
  plan: PropTypes.object.isRequired,
  activePlan: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired
};

function PlanItem({plan, activePlan, onSelect}) {
  function selectPlan() {
    onSelect(plan.id);
  }

  function render() {
    const color = plan.color;

    let isActivePlan = plan.id === activePlan;

    let displayRequests = plan.requestQuota.toLocaleString();

    let displayOverage = utils.numberWithCommas(plan.overage);

    return (
      <PlanContainer background={plan.background} color={plan.checkColor} active={isActivePlan} onClick={selectPlan}>
        <PlanRow>
          <Title color={color}>{upperFirst(plan.name)}</Title>

          <PlanCheckIcon color={plan.checkColor} isActive={isActivePlan} />
        </PlanRow>

        <PlanRow>
          <div>
            <ContentContainer>
              <MainText color={color}>${plan.price}&nbsp;pm</MainText>
              <Devider color={color}>|</Devider>
              <MainText color={color}>{displayRequests}&nbsp;Req</MainText>
            </ContentContainer>

            <RequestContainer>
              <RequestText color={color}>${displayOverage}</RequestText>
              <RequestDevider color={color}>|</RequestDevider>
              <RequestText color={color}>Per Req</RequestText>
            </RequestContainer>
          </div>

          <AppIcon name={plan.icon} />
        </PlanRow>
      </PlanContainer>
    );
  }

  return render();
}

export default PlanItem;
